module.exports = __webpack_public_path__ + "static/media/texel-logo.d9d67f93.png";